// Alles wat we naar de server schrijven gaat als JSON.
export const asJson = (method, data) => ({ method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });

// Eén doorgeefluik voor alles wat de app aan de server vraagt. Zonder tijdslimiet
// blijft een vraag die nooit antwoord krijgt eeuwig hangen: het molentje draait
// door en de foutopvang komt niet in actie, want er is geen fout. Na acht
// seconden breken we af; een ophaalvraag gaat daarna één keer opnieuw.
// Versturen niet: een tweede POST zou een dubbele regel maken.
export const API_MS = 8000, API_UPLOAD_MS = 20000, IDLE_MS = 120000;

export const api = async (url, opts) => {
  const method = ((opts && opts.method) || 'GET').toUpperCase();
  const upload = !!(opts && opts.body && typeof FormData !== 'undefined' && opts.body instanceof FormData);
  const budget = upload ? API_UPLOAD_MS : API_MS;
  const tries = method === 'GET' ? 2 : 1;
  let last = null;
  for (let n = 0; n < tries; n++) {
    const ac = new AbortController();
    // De klok loopt door tot het antwoord ook uitgelezen is; afbreken na afloop
    // doet niets, dus die tijdklok mag gewoon uitlopen.
    setTimeout(() => { try { ac.abort(); } catch (e) {} }, budget);
    try {
      return await fetch(url, Object.assign({}, opts, { signal: ac.signal }));
    } catch (e) {
      last = e;
    }
    if (n + 1 < tries) await new Promise((r) => setTimeout(r, 600));
  }
  throw last || new Error('geen antwoord van de server');
};

// De server zet de echte reden in het antwoord; die zegt meer dan een statuscode.
export async function serverMsg(res) {
  try { const j = await res.json(); if (j.message) return j.message; } catch (e) {}
  return `Server antwoordde ${res.status}.`;
}
